"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingSummary = void 0;
const lodash_1 = require("lodash");
var RatingSummary;
(function (RatingSummary) {
    function fromCachedValues(ratings) {
        const sum = (0, lodash_1.sumBy)(ratings, lodash_1.toNumber);
        return {
            average: ratings.length > 0 ? sum / ratings.length : undefined,
            count: ratings.length,
        };
    }
    RatingSummary.fromCachedValues = fromCachedValues;
})(RatingSummary || (exports.RatingSummary = RatingSummary = {}));
//# sourceMappingURL=RatingSummary.js.map